import {connect} from "react-redux";
import CarServiceAccountView from "./view";
import {bindActionCreators} from "redux";
import {accountById} from "../../../../service/Valet/action";
import {locationPinCode} from "../../../../service/locations/action";
import {oemManufactureName, sitePocTypes} from "../../../../service/CarService/action";
const mapStateToProps = (state) => ({
    accountByIdDetails:state.Valet.accountById,
    pincodeData: state.locationReducer.pincodeData,
    eomName:state.CarService.eomName,
    pocTypes:state.CarService.pocTypes,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            accountById,
            locationPinCode,
            oemManufactureName,
            sitePocTypes
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(CarServiceAccountView);
